import { useTheme } from "@emotion/react";
import { Icon, Typography } from "@fullscript/aviary-web";
import { faCheck } from "@fullscript/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import FullscriptLogoGreySVGComponent from "@shared/assets/logo/FullscriptLogoGrey";
import FullscriptLogoLeafSVGComponent from "@shared/assets/logo/FullscriptLogoLeaf";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./ValuePropsCard.styles";

const ValuePropsCard = () => {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();

  const renderValuePropLine = (label: string, value: string) => {
    return (
      <div css={styles.valuePropItem}>
        <div css={styles.checkmarkIcon}>
          <Icon icon={faCheck} size="small" />
        </div>
        <Typography isMarginless>
          <Typography as="span" fontWeight="bold">
            {label}
          </Typography>
          {value}
        </Typography>
      </div>
    );
  };

  const renderLogo = () => {
    if (theme === "dark") {
      return <FullscriptLogoLeafSVGComponent css={styles.logo} />;
    }

    return <FullscriptLogoGreySVGComponent css={styles.logo} />;
  };

  return (
    <div css={styles.valuePropsCard}>
      <div css={styles.valuePropTitle}>
        {renderLogo()}
        <Typography variant={tablet.greaterThan ? "h4" : "h5"} fontWeight="bold">
          {t(l.signIn.valuePropsCard.title)}
        </Typography>
      </div>
      <div css={styles.valuePropsList}>
        {renderValuePropLine(
          t(l.signIn.valuePropsCard.valueProps.authenticProductsOnly.label),
          t(l.signIn.valuePropsCard.valueProps.authenticProductsOnly.value)
        )}
        {renderValuePropLine(
          t(l.signIn.valuePropsCard.valueProps.everyProductTested.label),
          t(l.signIn.valuePropsCard.valueProps.everyProductTested.value)
        )}
        {renderValuePropLine(
          t(l.signIn.valuePropsCard.valueProps.neverMissADose.label),
          t(l.signIn.valuePropsCard.valueProps.neverMissADose.value)
        )}
      </div>
    </div>
  );
};

export { ValuePropsCard };
